import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "introduction-to-analytics"
    }}>{`Introduction to Analytics`}</h1>
    <p>{`For a modern e-commerce application, analytics is a must needed tool. In Chawkbazar, we have already some basic analytical widgets. But we are working on to add more widgets day by day. `}</p>
    <p>{`Here is the lists of some analytical widgets presented currently.`}</p>
    <ul>
      <li parentName="ul">{`Basic Summary`}</li>
      <li parentName="ul">{`Order status widgets`}</li>
      <li parentName="ul">{`Recent orders`}</li>
      <li parentName="ul">{`Sale history`}</li>
      <li parentName="ul">{`Popular products`}</li>
      <li parentName="ul">{`Low stock products`}</li>
      <li parentName="ul">{`Top 10 most rated products`}</li>
      <li parentName="ul">{`Top 10 categories with most products.`}</li>
      <li parentName="ul">{`Recent withdrawal`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Super Admin Analytic dashboard`}</p>
    </blockquote>
    <p><img alt="root-dashboard" src={require("../images/revamp/anylitics-dashboard.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{`Vendor Analytic dashboard `}</p>
    </blockquote>
    <p>{`In vendor dashboard there are some changes from Super Admin dashboard area. Please check the screenshot below.`}</p>
    <p><img alt="vendor-analytic-dashboard" src={require("../images/revamp/vendor-analytic-dashboard.png")} /></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      